import { FormControl, FormLabel, Text } from "@chakra-ui/react";

export const labelProps = {
  fontSize: 13,
  fontWeight: "500",
  color: "#666",
  textTransform: "capitalize",
  mb: 2,
};

export const inputProps = {
  bg: "white",
  color: "#333",
  border: "1px solid #DDD",
  borderRadius: 4,
  fontSize: 13,
};

export const readOnlyInputProps = {
  ...inputProps,
  isReadOnly: true,
  bg: "#F5F5F5",
};

export const Field = ({ label, error, children }) => (
  <FormControl isInvalid={!!error}>
    <FormLabel {...labelProps}>{label}</FormLabel>
    {children}
    {error && (
      <Text color="red.600" fontSize={12} mt={1}>
        {error}
      </Text>
    )}
  </FormControl>
);